"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _marketingBanners = _interopRequireDefault(require("../api/marketing-banners.store"));
var _searchPage = _interopRequireDefault(require("./base/search-page.store"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
var _class;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CompleteSearchPageStore = exports.default = (_class = function (_SearchPageStore) {
  (0, _inherits2.default)(CompleteSearchPageStore, _SearchPageStore);
  function CompleteSearchPageStore(initialState, $env, flightInfo) {
    var _this;
    if (initialState === void 0) {
      initialState = {};
    }
    (0, _classCallCheck2.default)(this, CompleteSearchPageStore);
    _this = _callSuper(this, CompleteSearchPageStore, [initialState, $env, flightInfo]);
    _this.marketingBanners = void 0;
    _this.marketingBanners = new _marketingBanners.default(initialState.marketingBanners, $env);
    return _this;
  }
  (0, _createClass2.default)(CompleteSearchPageStore, [{
    key: "marketingCampaigns",
    get: function get() {
      return this.marketingBanners.getValidCampaigns({
        route: this.searchRoute,
        airlines: this.availableAirlines,
        searchType: this.searchResults.searchRequest.searchType,
        isDomesticKSA: this.searchResults.searchRequest.isDomesticKSA
      });
    }
  }, {
    key: "marketingCampaignsMap",
    get: function get() {
      return (0, _keyBy2.default)(this.marketingCampaigns, function (campaign) {
        return campaign.position;
      });
    }
  }, {
    key: "topCampaign",
    get: function get() {
      return this.marketingBanners.topCampaign({
        route: this.searchRoute,
        airlines: this.availableAirlines,
        searchType: this.searchResults.searchRequest.searchType,
        isDomesticKSA: this.searchResults.searchRequest.isDomesticKSA
      });
    }
  }]);
  return CompleteSearchPageStore;
}(_searchPage.default), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "marketingCampaigns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "marketingCampaigns"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "marketingCampaignsMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "marketingCampaignsMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topCampaign", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topCampaign"), _class.prototype)), _class);